// File: src/components/admin/ServiceRequests.jsx
import React, { useEffect, useState } from "react";
import "./ServiceRequests.css";

function ServiceRequests() {
  const [requests, setRequests] = useState([]);
  const [search, setSearch] = useState("");
  const [statusFilter, setStatusFilter] = useState("");
  const [selectedRequest, setSelectedRequest] = useState(null);

  // Fetch requests from backend
  const fetchRequests = () => {
    fetch("https://api.kemari-corp.com/getServiceRequests.php")
      .then((res) => res.json())
      .then((data) => {
        if (data.status === "success") {
          setRequests(data.data);
        }
      })
      .catch((err) => console.error("Fetch error:", err));
  };

  useEffect(() => {
    fetchRequests();
  }, []);

  // Update status
  const updateStatus = (id, status) => {
    setRequests(requests.map((r) => (r.id === id ? { ...r, status } : r)));

    if (selectedRequest && selectedRequest.id === id) {
      setSelectedRequest((prev) => ({ ...prev, status }));
    }

    fetch("https://api.kemari-corp.com/updateServiceRequestStatus.php", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ id, status }),
    })
      .then((res) => res.json())
      .then((data) => {
        if (data.status !== "success") fetchRequests();
      })
      .catch(() => fetchRequests());
  };

  // Filter & search
  const displayedRequests = requests.filter((r) => {
    return (
      (statusFilter === "" || r.status === statusFilter) &&
      (r.name.toLowerCase().includes(search.toLowerCase()) ||
        r.email.toLowerCase().includes(search.toLowerCase()) ||
        r.service.toLowerCase().includes(search.toLowerCase()) ||
        (r.details && r.details.toLowerCase().includes(search.toLowerCase())))
    );
  });

  const statusClass = (status) => {
    if (status === "Contacted") return "contacted";
    if (status === "Quoted") return "quoted";
    return "new";
  };

  return (
    <div className="sr-root">
      {/* Page Header */}
      <div className="sr-page-header">
        <h2 className="sr-headline">Service Requests</h2>
      </div>

      {/* Filter / Search */}
      <div className="sr-filter-bar">
        <div className="sr-search-wrap">
          <svg className="sr-search-icon" viewBox="0 0 20 20" fill="none">
            <circle cx="9" cy="9" r="6" stroke="currentColor" strokeWidth="1.5" />
            <path d="M13.5 13.5L17 17" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
          </svg>
          <input
            type="text"
            className="sr-search"
            placeholder="Search requests…"
            value={search}
            onChange={(e) => setSearch(e.target.value)}
          />
        </div>
        <div className="sr-pill-group">
          {["", "New", "Contacted", "Quoted"].map((val) => (
            <button
              key={val}
              className={`sr-pill ${statusFilter === val ? "active" : ""}`}
              onClick={() => setStatusFilter(val)}
            >
              {val === "" ? "All" : val}
            </button>
          ))}
        </div>
      </div>

      {/* Request List */}
      <div className="sr-list">
        {displayedRequests.length === 0 ? (
          <p className="sr-empty">No service requests found</p>
        ) : (
          displayedRequests.map((r, i) => (
            <div
              key={r.id}
              className="sr-row"
              style={{ animationDelay: `${i * 40}ms` }}
              onClick={() => setSelectedRequest(r)}
            >
              <div className="sr-avatar">
                {r.name.charAt(0).toUpperCase()}
              </div>

              <div className="sr-row-info">
                <span className="sr-row-name">{r.name}</span>
                <span className="sr-row-email">{r.email}</span>
              </div>

              <div className="sr-row-right">
                <span className={`sr-badge ${statusClass(r.status)}`}>
                  {r.status || "New"}
                </span>
                <svg className="sr-chevron" viewBox="0 0 8 14" fill="none">
                  <path d="M1 1l6 6-6 6" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                </svg>
              </div>
            </div>
          ))
        )}
      </div>

      {/* Modal */}
      {selectedRequest && (
        <div className="sr-overlay" onClick={() => setSelectedRequest(null)}>
          <div className="sr-modal" onClick={(e) => e.stopPropagation()}>

            {/* Fixed top */}
            <div className="sr-modal-fixed-top">
              <div className="sr-handle" />
              <div className="sr-modal-top">
                <div className="sr-modal-avatar">
                  {selectedRequest.name.charAt(0).toUpperCase()}
                </div>
                <div className="sr-modal-meta">
                  <p className="sr-modal-name">{selectedRequest.name}</p>
                  <p className="sr-modal-email">{selectedRequest.email}</p>
                  <p className="sr-modal-service">{selectedRequest.service}</p>
                </div>
                <span className={`sr-badge ${statusClass(selectedRequest.status)}`}>
                  {selectedRequest.status || "New"}
                </span>
              </div>
              <div className="sr-modal-divider" />
            </div>

            {/* Scrollable middle */}
            <div className="sr-modal-scroll">
              {selectedRequest.details ? (
                <p className="sr-modal-body">{selectedRequest.details}</p>
              ) : (
                <p className="sr-modal-empty">No additional details provided.</p>
              )}
            </div>

            {/* Fixed bottom */}
            <div className="sr-modal-fixed-bottom">
              <div className="sr-modal-actions">
                <div className="sr-status-wrap">
                  <span className="sr-status-label">Status</span>
                  <select
                    className="sr-status-select"
                    value={selectedRequest.status || "New"}
                    onChange={(e) => updateStatus(selectedRequest.id, e.target.value)}
                  >
                    <option value="New">New</option>
                    <option value="Contacted">Contacted</option>
                    <option value="Quoted">Quoted</option>
                  </select>
                </div>

                <a
                  href={`https://mail.google.com/mail/?view=cm&to=${selectedRequest.email}&subject=Re: Your Service Request&body=Hello ${selectedRequest.name},`}
                  target="_blank"
                  rel="noreferrer"
                  className="sr-reply-btn"
                >
                  ✉ Reply via Email
                </a>
              </div>

              <button className="sr-close-btn" onClick={() => setSelectedRequest(null)}>
                Close
              </button>
            </div>

          </div>
        </div>
      )}
    </div>
  );
}

export default ServiceRequests;